/** @jsx jsx */
import { css, jsx, styled } from '@compiled/react';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { N70 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line import/order
import { AiIcon } from '@atlassian/jira-atlassian-intelligence/src/common/ui/ai-icon/index.tsx';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const AiFooter = () => {
	const { formatMessage } = useIntl();
	return (
		<Box paddingBlock="space.050" xcss={aiInfoContainerStyles}>
			<Inline role="note" grow="fill" alignBlock="center" xcss={inlineBlockStyles}>
				<EditorPanelIcon
					label="infoIcon"
					size="medium"
					primaryColor={token('color.icon.subtle', N70)}
				/>
				<AiLink href="https://www.atlassian.com/trust/atlassian-intelligence" target="_blank">
					{formatMessage(messages.contentQualityStatement)}
				</AiLink>
				<Lozenge appearance="default">{formatMessage(messages.betaAccessLozenge)} </Lozenge>
				<div css={footerNoteTextStyles}>
					{formatMessage(messages.aiNote)}
					<Box paddingInline="space.050" xcss={aiIconContainerStyles}>
						<AiIcon label="aiIcon" isDisabled size="small" />
					</Box>
				</div>
			</Inline>
		</Box>
	);
};
const aiInfoContainerStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderTop: `1px solid ${token('color.border', colors.N40)}`,
});

const aiIconContainerStyles = xcss({
	height: '24px',
	display: 'flex',
	alignItems: 'center',
});

const inlineBlockStyles = xcss({
	paddingLeft: 'space.200',
});

const footerNoteTextStyles = css({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	font: token('font.body.small', fontFallback.body.small),
	color: token('color.text.subtlest'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	paddingLeft: `${gridSize * 21}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AiLink = styled.a({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	font: token('font.body.small', fontFallback.body.small),
	color: token('color.text.subtlest', '#626F86'),
	marginRight: token('space.050', '4px'),
	'&:hover': {
		color: `${token('color.text.subtlest', '#626F86')}`,
	},
	'&:visited': {
		color: `${token('color.text.subtlest', '#626F86')}`,
	},
});
